import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IonButton, IonCol, IonGrid, IonIcon, IonRow } from '@ionic/angular/standalone';
import { INavAction } from '../../models';

/**
 * Footer actions of a page: only the primary actions belong here, the secondary ones
 * stay in the top bar. The caller decides which actions to pass.
 */
@Component({
  selector: 'lib-footer-actions',
  templateUrl: './footer-actions.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonButton, IonCol, IonGrid, IonIcon, IonRow],
})
export class FooterActionsComponent {
  public readonly actions = input.required<INavAction[]>();

  // The footer is built with text buttons, so actions without a label are skipped.
  protected readonly footerActions = computed(() => this.actions().filter((action) => !!action.label));
}
